/* Types */
import type {
  PlaceDetailsFieldType,
  AddressConfigType,
} from 'types/GooglePlacesTypes';

export const SIGNUP_SCREEN = {
  CREATE_ACCOUNT: 'CREATE_ACCOUNT',
  STORE_TYPE: 'STORE_TYPE',
  STORE_NAME: 'STORE_NAME',
  STORE_ADDRESS: 'STORE_ADDRESS',
  STORE_HOURS: 'STORE_HOURS',
  STORE_CATEGORY: 'STORE_CATEGORY',
  SUCCESS: 'SUCCESS',
  UNSUPPORTED_STORE_TYPE: 'UNSUPPORTED_STORE_TYPE',
} as const;

export const SIGNUP_SCREEN_ORDER = {
  CREATE_ACCOUNT: 1,
  STORE_TYPE: 2,
  STORE_NAME: 3,
  STORE_ADDRESS: 4,
  STORE_HOURS: 5,
  STORE_CATEGORY: 6,
  SUCCESS: 7,
} as const;

export const BLUE_SIGNUP_USER_ALREADY_EXISTS_CODE = 73;
export const MIN_PASSWORD_LENGTH = 8;
export const MAX_PASSWORD_LENGTH = 30;

export const MERCHANT_TOS_URL = 'https://merchant.wish.com/terms-of-service';

export const STORE_TYPE = {
  HOME: 0,
  RETAIL: 1,
} as const;

export const CS_STORE_TYPE = {
  RETAIL: 0,
  HOME: 1,
} as const;

// these are the fields we request from the Google Place Details API
export const AUTOCOMPLETE_DETAILS_FIELDS: Array<PlaceDetailsFieldType> = [
  'place_id',
  'name',
  'types',
  'address_component',
  'formatted_address',
  'business_status',
  'geometry',
  'utc_offset',
  'vicinity',
  'photos',
  'url',
  'formatted_phone_number',
  'international_phone_number',
  'opening_hours',
  'website',
  'rating',
  'user_ratings_total',
];

// Countries for which we should use the LATAM address format:
// street name before street number, and including neighbourhood if possible
export const LATAM_ADDRESS_COUNTRIES = new Set<string>([
  'AR',
  'BO',
  'BR',
  'CL',
  'CO',
  'CR',
  'CU',
  'EC',
  'SV',
  'GT',
  'HN',
  'MX',
  'NI',
  'PA',
  'PY',
  'PE',
  'UY',
  'VE',
]);

export const LATAM_NEIGHBOURHOOD_PREFIX: {
  [countryCode: string]: string | undefined;
} = {
  MX: 'Col. ',
  BR: 'Bairro ',
};

// countries that we have incorrect States info on file
export const INCORRECT_STATES_COUNTRIES = new Set<string>(['MX']);

export const ADDRESS_FORMAT: AddressConfigType = {
  MX: {
    storeAddressLine1: {
      order: [['route', 'street_number'], ['subpremise'], ['premise']],
      fullName: false,
    },
    storeAddressLine2: {
      order: [['neighborhood'], ['sublocality_level_1']],
      fullName: false,
    },
    city: { order: [['locality']], fullName: true },
    zipCode: { order: [['postal_code']], fullName: true },
  },
  BR: {
    storeAddressLine1: {
      order: [
        ['route'],
        ['street_number'],
        ['subpremise'],
        ['sublocality_level_1'],
        ['sublocality_level_2'],
        ['sublocality_level_3'],
        ['sublocality_level_4'],
        ['sublocality_level_5'],
      ],
      fullName: false,
    },
    storeAddressLine2: {
      order: [['premise']],
      fullName: false,
    },
    city: {
      order: [['administrative_area_level_4'], ['administrative_area_level_2']],
      fullName: true,
    },
    zipCode: { order: [['postal_code']], fullName: true },
  },
  EC: {
    storeAddressLine1: {
      order: [
        ['route', 'street_number'],
        ['subpremise'],
        ['neighborhood'],
        ['sublocality_level_1'],
      ],
      fullName: false,
    },
    storeAddressLine2: {
      order: [['premise']],
      fullName: false,
    },
    city: {
      order: [['locality']],
      fullName: true,
    },
    zipCode: { order: [['postal_code']], fullName: true },
  },
};
